<template>
  <div>
    <dashboard-component :settings="settings"></dashboard-component>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {useRoute} from "vue-router/dist/vue-router";
import {computed, onMounted, ref, watch} from "vue";
import DashboardComponent from "./DashboardComponent.vue";
import dashboardRepository from "#repositories/dashboardRepository";
import _ from 'lodash'

 export default {
  name: "DashboardsShow",
  components:{
    DashboardComponent
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const currentDashboard = ref({})
    const settings = ref({})

    function fetchDashboard(){
      dashboardRepository.getUniqueDashboard(route.params.dashboard_id).then((response) => {
        currentDashboard.value = response.data;
      })
    }

    watch(
        () => currentDashboard.value,
        () => {
          settings.value = currentDashboard.value.settings.resource
        }
    )

    onMounted(() => {
      fetchDashboard()
    })

    return {
      currentDashboard,
      settings
    }
  }
}
</script>

<style lang="scss" scoped>

</style>